import React from 'react'
import { AppHeader } from '../components/index'
const Dashboard = React.lazy(() => import('../views/assesment/dashboard/reports'))

const ReportLayout = () => {
  return (
    <div className="wrapper d-flex flex-column min-vh-100 bg-light">
      <AppHeader />
      <div className="report__layout">
        <Dashboard />
      </div>
    </div>
  )
}

export default ReportLayout 